import { render, staticRenderFns } from "./CUHKSZOAuth.vue?vue&type=template&id=68c01cde&scoped=true&"
import script from "./CUHKSZOAuth.vue?vue&type=script&lang=js&"
export * from "./CUHKSZOAuth.vue?vue&type=script&lang=js&"
import style0 from "./CUHKSZOAuth.vue?vue&type=style&index=0&id=68c01cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c01cde",
  null
  
)

export default component.exports